module.exports = __webpack_public_path__ + "img/detail-m.58839b27.png";